import { isObject } from './functions';

type TData = string|number|null|undefined|Object;

export const objectNullValuesToEmptyStrings = (data: TData): TData => {
  if (data && isObject(data)) {
    for (const object in (data as Object)) {
      const value = data[object as (keyof TData)];

      if (!value) {
        (data[object as (keyof TData)] as Object) = '';
      } else {
        objectNullValuesToEmptyStrings(value);
      }
    }
  }

  return data ? data : '';
};
